var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagesIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14H19",
    stroke: "#FFE500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18H19",
    stroke: "#FFE500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9915 24.655C13.092 25.8707 15.5629 26.281 17.9435 25.8094C20.3241 25.3378 22.452 24.0165 23.9304 22.0918C25.4088 20.1671 26.1368 17.7704 25.9788 15.3486C25.8207 12.9268 24.7873 10.6451 23.0712 8.92894C21.3551 7.2128 19.0735 6.17934 16.6518 6.02125C14.2301 5.86316 11.8335 6.59122 9.90892 8.06969C7.98433 9.54816 6.66307 11.6761 6.1915 14.0569C5.71992 16.4376 6.13021 18.9086 7.34586 21.0091L6.0428 24.8997C5.99383 25.0466 5.98673 25.2041 6.02228 25.3548C6.05783 25.5054 6.13463 25.6432 6.24407 25.7526C6.35351 25.8621 6.49127 25.9389 6.6419 25.9744C6.79254 26.01 6.95009 26.0029 7.09692 25.9539L10.9915 24.655Z",
    stroke: "#FFE500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIconActive);
export default __webpack_public_path__ + "static/media/MessagesIconActive.feb2ee808daf485a9ea5e6d7239c9ea2.svg";
export { ForwardRef as ReactComponent };